import { __ } from '@wordpress/i18n';
import { ThemeBuilderSelect } from 'jkit-core/control';
import { useState } from 'react';
import { updateOption } from '../../helper/axios';
import SaveButton from './save-button';


const GlobalStyle = ({ setSnackbar }) => {
    const { globalStyle } = window['JkitDashboardOption'];
    const [isSave, setIsSave] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [value, setValue] = useState(globalStyle?.selected !== undefined ? globalStyle.selected : '');
    const choices = globalStyle.choices;
    const saveOption = async () => {
        const params = {
            option_name: 'elementor_active_kit',
            options: value,
            auto_load: false
        }
        await updateOption(params).then(res => {
            if (res) {
                setIsSaved(true);
                window['JkitDashboardOption'].globalStyle.selected = value;
                setSnackbar(__('Change Saved', 'jeg-elementor-kit'));
            } else {
                setSnackbar(__('Saved Failed', 'jeg-elementor-kit'));
            }
            setTimeout(() => {
                setIsSaved(false);
                setIsSave(false);
            }, 1000);
        });
    };

    const updateValue = (id, value) => {
        setValue(value)
    }
    return (
        <div className="content-wrapper general">
            <h3>{__('Choose Global Style', 'jeg-elementor-kit')}</h3>
            <div className='control-wrapper'>
                <ThemeBuilderSelect
                    id={'global-style'}
                    choices={choices}
                    updateValue={updateValue}
                    value={value}
                />
                <SaveButton isSaved={isSaved} isSave={isSave} onSave={saveOption} />
            </div>
            <span className='option-desc'>Here you can switch the Elementor global style.</span>
        </div>
    );
};

export default GlobalStyle;
